"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalServerErrorResponse = exports.forbiddenResponse = exports.badRequestResponse = exports.errorResponses = exports.successResponse = exports.genericSchema = void 0;
const errors_1 = require("../errors");
const metadata_1 = require("./metadata");
const ref_1 = require("./ref");
function genericSchema(factory) {
    const cache = new Map();
    return (type) => {
        if (cache.has(type)) {
            return cache.get(type);
        }
        const schema = factory(type);
        cache.set(type, schema);
        return schema;
    };
}
exports.genericSchema = genericSchema;
function successResponse(params) {
    return {
        description: params.description || 'OK',
        content: {
            'application/json': {
                schema: {
                    type: 'object',
                    properties: {
                        data: params.schema,
                    },
                },
            },
        },
    };
}
exports.successResponse = successResponse;
function errorResponses(extraDescriptions = {}) {
    const result = {
        400: {
            description: [
                'Resource does not exist',
                'Invalid request',
                'Validation error',
                'Database constraint error',
                ...(extraDescriptions[400] || []),
            ].join('<br>'),
        },
        403: {
            description: [
                'Insufficient permissions',
                ...(extraDescriptions[403] || []),
            ].join('<br>'),
        },
    };
    for (const [status, messages] of Object.entries(extraDescriptions)) {
        if (!result[status]) {
            result[status] = {
                description: messages.join('<br>'),
            };
        }
    }
    return result;
}
exports.errorResponses = errorResponses;
function badRequestResponse() {
    return {
        description: 'Bad Request',
        content: {
            'application/json': {
                schema: {
                    type: 'object',
                    properties: {
                        error: {
                            oneOf: [
                                (0, ref_1.ref)(() => GenericError),
                                (0, ref_1.ref)(() => errors_1.Errors.EventError),
                                (0, ref_1.ref)(() => errors_1.Errors.QueryParameterError),
                                (0, ref_1.ref)(() => errors_1.Errors.OperationError),
                                (0, ref_1.ref)(() => errors_1.Errors.ModelValidationError),
                                (0, ref_1.ref)(() => errors_1.Errors.MismatchedContextOrgError),
                                (0, ref_1.ref)(() => errors_1.Errors.ValidationError),
                                (0, ref_1.ref)(() => errors_1.Errors.RecordOutOfDateError),
                                (0, ref_1.ref)(() => errors_1.Errors.TooManyResultsError),
                            ],
                        },
                    },
                },
            },
        },
    };
}
exports.badRequestResponse = badRequestResponse;
function forbiddenResponse() {
    return {
        description: 'Forbidden',
        content: {
            'application/json': {
                schema: {
                    type: 'object',
                    properties: {
                        error: {
                            oneOf: [
                                (0, ref_1.ref)(() => errors_1.Errors.PermissionError),
                                (0, ref_1.ref)(() => errors_1.Errors.AppAccessError),
                            ],
                        },
                    },
                },
            },
        },
    };
}
exports.forbiddenResponse = forbiddenResponse;
function internalServerErrorResponse() {
    return {
        description: 'Internal Server Error',
        content: {
            'application/json': {
                schema: {
                    type: 'object',
                    properties: {
                        error: (0, ref_1.ref)(() => GenericError),
                    },
                },
            },
        },
    };
}
exports.internalServerErrorResponse = internalServerErrorResponse;
class GenericError {
    name;
    message;
    stack;
    code;
}
__decorate([
    (0, metadata_1.Schema)({ type: 'string' })
], GenericError.prototype, "name", void 0);
__decorate([
    (0, metadata_1.Schema)({ type: 'string' })
], GenericError.prototype, "message", void 0);
__decorate([
    (0, metadata_1.Schema)({ type: 'string' })
], GenericError.prototype, "stack", void 0);
__decorate([
    (0, metadata_1.Optional)(),
    (0, metadata_1.Schema)({ type: 'string' })
], GenericError.prototype, "code", void 0);
